import React from 'react';
import { useTranslation } from 'react-i18next';

import { Text16 } from '../../../ui/Text16';
import EmailIcon from '../../../assets/FooterLogos/email.svg';
import PhoneIcon from '../../../assets/FooterLogos/phone.svg';
import CalendarIcon from '../../../assets/FooterLogos/calendar.svg';
import ClockIcon from '../../../assets/FooterLogos/clock.svg';
import {    
    FooterMenuTitle,
    FooterMenuLinks,
    FooterContactItem,
    FooterContactText,
    FooterItem
  } from '../footer.style';

export const Contacts: React.FC<{}> = () => {
    const { t } = useTranslation();
    return (
        <FooterItem>
            <FooterMenuTitle>{t('contacts')}</FooterMenuTitle>            
            <FooterContactItem>
                <img
                    src={EmailIcon}
                    alt='Email'
                    loading='lazy'
                />
                <FooterMenuLinks
                    onClick={() => window.open('mailto:easig@simpals.com')}
                >
                    <Text16>easig@simpals.com</Text16>
                </FooterMenuLinks>
            </FooterContactItem>
            <FooterContactItem>
                <img
                    src={PhoneIcon}
                    alt='Phone'
                    loading='lazy'
                />
                <FooterMenuLinks
                    onClick={() => window.open('tel:37322888960')}
                >
                    <Text16>022 888 960</Text16>
                </FooterMenuLinks>
            </FooterContactItem>
            <FooterContactItem>
                <img
                    src={CalendarIcon}
                    alt='Calendar'
                    loading='lazy'
                />
                <FooterContactText>
                    <Text16>{t('work_days_hours')}</Text16>
                </FooterContactText>
            </FooterContactItem>
            <FooterContactItem>
                <img
                    src={ClockIcon}
                    alt='Clock'
                    loading='lazy'
                />
                <FooterContactText>
                    <Text16>{t('lunch_break')}</Text16>
                </FooterContactText>
            </FooterContactItem>    
        </FooterItem>
    )
}